const Loader = () => {
    return (
        <div className="animate-fadeInOut">
            <img src="/images/icon-2.svg"  alt="Loading..." />
        </div>
    );
}

export default Loader;
